module.exports = __webpack_public_path__ + "static/media/soundpong.100a6590.gif";